<div class="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-12 font-sans">
  <div class="w-full max-w-sm">

    <!-- Logo + heading -->
    <div class="mb-8 flex flex-col items-center text-center">
      <div class="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-600 shadow-sm">
        <lucide-icon name="zap" [size]="22" color="white" [strokeWidth]="2.5"></lucide-icon>
      </div>
      <h1 class="text-xl font-semibold text-slate-900">Reset your password</h1>
      <p class="mt-1.5 text-sm text-slate-500">We'll email you a code to set a new one.</p>
    </div>

    <!-- Card -->
    <div class="rounded-2xl border border-slate-200 bg-white px-6 py-7 shadow-sm">
      <form (ngSubmit)="onSubmit()" novalidate>

        <!-- Error banner -->
        <div *ngIf="error" class="mb-5 flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
          <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-500" [strokeWidth]="2"></lucide-icon>
          <p class="text-sm text-red-700">{{ error }}</p>
        </div>

        <!-- Email -->
        <div class="mb-6">
          <label for="email" class="mb-1.5 block text-xs font-medium text-slate-700">Email</label>
          <input
            id="email"
            type="email"
            name="email"
            [(ngModel)]="email"
            required
            autocomplete="email"
            placeholder="you@example.com"
            class="block w-full rounded-lg border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none focus:ring-2 focus:ring-violet-100 transition-shadow"
          />
        </div>

        <!-- Submit: enabled while idle so browser autofill can't strand it disabled -->
        <button
          type="submit"
          [disabled]="loading"
          class="flex w-full items-center justify-center gap-2 rounded-lg bg-violet-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <lucide-icon *ngIf="loading" name="loader" [size]="15" class="animate-spin" [strokeWidth]="2.5"></lucide-icon>
          {{ loading ? 'Sending code...' : 'Send reset code' }}
        </button>

      </form>
    </div>

    <p class="mt-5 text-center text-sm text-slate-500">
      Remembered it?
      <a routerLink="/login" class="font-medium text-violet-600 hover:underline">Back to sign in</a>
    </p>
    <p class="mt-4 text-center text-xs text-slate-400">&copy; 2026 KernalHQ. All rights reserved.</p>
  </div>
</div>
